/*
* 项目回款弹框组件
*/

import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Row,
    Col,
    Modal,
    Button,
    message,
    Image,
    Statistic,
    Tag,
    theme,
} from 'antd';
import $ from 'jquery';
import cookie from 'react-cookies';
import CNF from '../../incs/Config.js';
import {
    Html2pdf,
    AddRequestHeaders,
    UjoinParams,
    AliyunOSSclient,
    defaultImage,
    locale,
} from '../../incs/FunHelper.js';

import XZTLOGO from '../../images/logo_head.png';
import PAGEHEADERRIGHT from '../../images/page-header-right.png';

/**
 * 显示项目回款信息
 * @param {*} props 
 * @returns 
 */
const RepaymentInfo = (props) => {
    const [open, setOpen] = useState(props.open);
    const cancel = () => { setOpen(false); setImageList([]) }
    const [imageList, setImageList] = useState([]);

    const {
        token: {
            colorSuccess,
            colorSuccessBg,
        },
    } = theme.useToken();

    const printer = () => {
        var printContents = document.getElementById('print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };

    const download = () => { Html2pdf('print-info-id', props.record.project_name + '.' + props.record.date, imageList.length > 0 ? true : false); };

    /**
     * 获取图片列表
     */
    const getImageLists = (imageUri) => {
        let _imageList = [];
        let params = {
            'acl': 'GetObject'
        }
        $.ajax({
            url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    const token = data.dat;
                    let imageUris = imageUri.split(',');
                    for (let i = 0; i < imageUris.length; i++) {
                        let item = imageUris[i];
                        try {
                            //  去掉路径‘/’
                            let result = AliyunOSSclient(token).signatureUrl(item, {
                                expires: 3600,
                                response: {
                                    'content-disposition': 'attachment; filename="' + item.split('/').pop() + '"'
                                }
                            });
                            _imageList.push({
                                url: result,
                                preview: result,
                                status: 'done',
                                percent: 100,
                                path: item,
                                uid: i + 1,
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }
                    setImageList(_imageList);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    useEffect(() => {
        setOpen(props.open);
        if (props.record.image_uri) {
            getImageLists(props.record.image_uri);
        }
    }, [props]);
    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: {
                    colorPrimary: cookie.load(CNF.cookies.keyThemeColor) ? cookie.load(CNF.cookies.keyThemeColor) : CNF.themeColors[0],
                },
            }}
        >
            <Modal
                width={820}
                style={{ top: 0 }}
                closable={false}
                open={open}
                keyboard={true}
                maskClosable={true}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel}>取消</Button>,
                    <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download} style={{ marginRight: 20 }}>下载</Button>,
                ]}
            >
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Row style={{ margin: '10px' }}>
                            <Col span={2}><img src={XZTLOGO} height='45px' alt={CNF.companyShortName} /></Col>
                            <Col span={22} align='right'><img src={PAGEHEADERRIGHT} height='35px' alt={CNF.companyShortName} /></Col>
                        </Row>
                        <table width='100%'>
                            <thead align='center'>
                                <tr>
                                    <th colSpan='24'><h2>项目回款明细</h2></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>项目名称</td><td colSpan='19' style={{ width: 600 }}>{props.record.project_name}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>项目编号</td><td colSpan='19' style={{ width: 600 }}>{props.record.project_number}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>回款金额</td><td colSpan='8' style={{ width: 240 }}><Tag color={colorSuccessBg}><Statistic precision={CNF.DPL} suffix={props.record.amount > 10000 ? '万元' : '元'} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorSuccess }} value={props.record.amount >= 10000 ? props.record.amount / 10000 : props.record.amount} /></Tag></td>
                                    <td colSpan='4' style={{ width: 120 }}>回款日期</td><td colSpan='8' style={{ width: 240 }}>{props.record.date}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>付款方户名</td><td colSpan='8' style={{ width: 240 }}>{props.record.payer_name}</td>
                                    <td colSpan='4' style={{ width: 120 }}>付款方账户</td><td colSpan='8' style={{ width: 240 }}>{props.record.payer_account}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>收款方户名</td><td colSpan='8' style={{ width: 240 }}>{props.record.beneficiary_name}</td>
                                    <td colSpan='4' style={{ width: 120 }}>收款方账户</td><td colSpan='8' style={{ width: 240 }}>{props.record.beneficiary_account}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>回款人员</td><td colSpan='19' style={{ width: 600 }}>{props.record.personnel}</td>
                                </tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>备注:</td><td colSpan='19' style={{ width: 600 }}>
                                    {props.record.description && props.record.description.split('\n').map((item, index) => {
                                        return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                    })}
                                </td></tr>
                            </tbody>
                        </table>
                        <div>
                            {
                                imageList.length > 0 ? <p>附图: </p> : ''
                            }
                            {
                                imageList && imageList.map((item, index) => {
                                    return <Image
                                        className='whole-node'
                                        key={index}
                                        alt={CNF.companyShortName}
                                        width='33.3%'
                                        src={item.url}
                                        style={{ verticalAlign: 'top', maxWidth: '100%', height: 'auto' }}
                                        fallback={defaultImage}
                                    />
                                })
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        </ConfigProvider>
    );
};

export default RepaymentInfo